/* eslint-disable max-len */
import React, { useState } from 'react';
import { AudioManager } from '../../platform/AudioManager';
import { Colors } from '../../ui';
import { SliderWithInput } from '../../ui/SliderWithInput';
import { useResolve } from '../Container';
import { Flexer, Title } from '../dashboard/elements/LayoutElements';

export const VolumeSettingsWidget = () => {

    const audio = useResolve(AudioManager);
    const [value, setValue] = useState(audio.volume * 100);

    const applyVolume = (vol: number) => {
        audio.volume = vol / 100;
        setValue(vol);
    };

    return <Flexer width="20">
        <Flexer padding=".5 1" background={Colors.gray50} borderRadius="0.375rem 0.375rem 0 0" borderBottom={`solid .0625rem ${Colors.border}`}>
            <Title flush size="2xs" color={Colors.text} uppercase weight="500">Volume Settings</Title>
        </Flexer>
        <Flexer width="100%" padding="0.5">
            <SliderWithInput min={0} max={100} value={value} onChange={applyVolume} />
        </Flexer>
    </Flexer>;
};
